import { defineTour } from '@lopettia/simul';

/**
 * Tenant administrator — process config, user management, permissions,
 * and the new demo brand defaults page (epic 114, ticket 114.8).
 * Mirrors docs/manuals/04-tenant-admin.md.
 */
export const tenantAdminTour = defineTour({
  name: 'Tenant administrator setup',
  description:
    'Onboarding walkthrough for a Kairos tenant admin: processes, users, '
    + 'permissions, brand defaults.',
  steps: [
    {
      id: 'ta-process',
      kind: 'navigate',
      target: '[data-tour-id="nav-process-templates"]',
      toUrl: '/process-templates',
      prelude: { goto: '/dashboard' },
      message:
        '**Process templates** define the sales stages, gates, and SLAs '
        + 'your teams operate under.',
      advanceOn: 'navigate',
    },
    {
      id: 'ta-users',
      kind: 'navigate',
      target: '[data-tour-id="nav-users"]',
      toUrl: '/admin/users',
      message: 'Invite teammates and assign their primary role under **Users**.',
      advanceOn: 'navigate',
    },
    {
      id: 'ta-permissions',
      kind: 'navigate',
      target: '[data-tour-id="nav-permissions"]',
      toUrl: '/admin/permissions',
      message:
        '**Permissions** is where you tailor what each role can see and do.',
      advanceOn: 'navigate',
    },
    {
      id: 'ta-brand',
      kind: 'navigate',
      target: '[data-tour-id="nav-demo-brand-defaults"]',
      toUrl: '/admin/demos/brand-defaults',
      message:
        'Set **Demo brand defaults** so every published prospect demo '
        + 'inherits your colours, logo, and intro copy.',
      advanceOn: 'navigate',
    },
  ],
});

export default tenantAdminTour;
